import { useCallback } from 'react'

import api from './api'
import type { CreateOrderRequest, GetAvailabilityRequest, SendOrderConfirmationRequest } from './api.types'

const useApi = () => ({
  config: useCallback(() => api.config(), []),
  getProductCategories: useCallback(() => api.getProductCategories(), []),
  getProducts: useCallback((categoryId: number | string) => api.getProducts(categoryId), []),
  getAvailability: useCallback((request: GetAvailabilityRequest) => api.getAvailability(request), []),
  createOrder: useCallback((payload: CreateOrderRequest) => api.createOrder(payload), []),
  sendOrderConfirmation: useCallback((payload: SendOrderConfirmationRequest) => api.sendOrderConfirmation(payload), [])
})

export default useApi
